import React, { useRef, useImperativeHandle, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import './RichTextEditor.css'

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"]
  ],
};

// 🔥 simple formatter (beautify HTML)
const formatHTML = (html) => {
  if (!html) return "";

  return html
    .replace(/></g, ">\n<") // new line between tags
    .replace(/(<\/\w+>)/g, "$1\n") // closing tag line break
    .trim();
};

const RichTextEditor = React.forwardRef(({ value, onChange, ...props }, ref) => {
  const quillInstanceRef = useRef(null);
  const [isSourceMode, setIsSourceMode] = useState(false);

  useImperativeHandle(ref, () => ({
    focus: () => quillInstanceRef.current?.focus(),
    getEditor: () => quillInstanceRef.current?.getEditor(),
  }));

  return (
    <div className="rich-editor-wrapper">

      {/* 🔥 Toolbar */}
      <div className="editor-header">
        <button
          type="button"
          className={`toggle-btn ${!isSourceMode ? "active" : ""}`}
          onClick={() => setIsSourceMode(false)}
        >
          ✨ Visual
        </button>

        <button
          type="button"
          className={`toggle-btn ${isSourceMode ? "active" : ""}`}
          onClick={() => setIsSourceMode(true)}
        >
          {"</>"} Code
        </button>
      </div>

      {/* 🔥 Editor */}
      {/* {isSourceMode ? (
        <Code
          value={formatHTML(value)}
          onChange={(e) => onChange(e.target.value)}
          className="code-editor"
        />
      ) : ( */}
      {isSourceMode ? (
        <div className="code-card">
          <div className="code-header">
            <div className="code-title">
              <span className="code-dot red"></span>
              <span className="code-dot yellow"></span>
              <span className="code-dot green"></span>
              <span className="code-label">HTML Source</span>
            </div>

            <button
              type="button"
              className="copy-btn"
              onClick={() => navigator.clipboard.writeText(value)}
            >
              Copy
            </button>
          </div>

          <div className="code-body">
            <pre>
              <code
                contentEditable
                suppressContentEditableWarning
                className="code-editor"
                onInput={(e) => onChange(e.currentTarget.textContent)}
              >
                {formatHTML(value)}
              </code>
            </pre>
          </div>

        </div>
      ) : (
        <ReactQuill
          ref={quillInstanceRef}
          theme="snow"
          value={value || ""}
          onChange={onChange}
          modules={modules}
          className="quill-editor"
          {...props}
        />
      )}
    </div>
  );
});

export default RichTextEditor;